import { tw } from '@panwds/tailwindcss';
export function getTextColorClass({ disabled, isError, readOnly }) {
    if (isError) {
        return tw `tw-text-red-500`;
    }
    if (disabled || readOnly) {
        return tw `tw-text-white dark:tw-text-gray-1050`;
    }
    return tw `tw-text-blue-600 dark:tw-text-blue-600`;
}
export function getBorderClass({ disabled, isError, readOnly }) {
    const borderBaseClassDef = tw `tw-border-solid tw-border`;
    if (isError) {
        return tw `${borderBaseClassDef} tw-border-red-500 dark:tw-border-red-500 focus:tw-border-red-500 dark:focus:tw-border-red-500`;
    }
    if (disabled || readOnly) {
        return tw `${borderBaseClassDef} tw-border-gray-300 dark:tw-border-gray-800 checked:tw-border-gray-300`;
    }
    return tw `${borderBaseClassDef} tw-border-gray-500 dark:tw-border-gray-500 checked:tw-border-none dark:checked:tw-border-none`;
}
export function getBackgroundClass({ disabled, isError, readOnly, checked, indeterminate }) {
    const backgroundBaseClassDef = tw `tw-bg-white dark:tw-bg-black tw-bg-opacity-80 dark:tw-bg-opacity-16`;
    if (isError) {
        return tw `${backgroundBaseClassDef} checked:tw-bg-red-500 dark:checked:tw-bg-red-500`;
    }
    if ((checked || indeterminate) && (disabled || readOnly)) {
        return tw `${backgroundBaseClassDef} checked:tw-bg-gray-300 dark:checked:tw-bg-gray-800 hover:checked:tw-bg-gray-300 hover:dark:checked:tw-bg-gray-800 indeterminate:tw-bg-gray-300 dark:indeterminate:tw-bg-gray-800 hover:indeterminate:tw-bg-gray-300 hover:dark:indeterminate:tw-bg-gray-800`;
    }
    return tw `${backgroundBaseClassDef} dark:checked:tw-bg-blue-600 dark:indeterminate:tw-bg-blue-600`;
}
export function getOutlineClass({ isHovered, isFocused, disabled, readOnly }) {
    if (isFocused) {
        return tw `focus:tw-outline-blue-200 dark:focus:tw-outline-gray-700 focus:tw-outline-offset-0`;
    }
    if (isHovered && !(disabled || readOnly)) {
        return tw `tw-outline hover:tw-outline-2 hover:tw-outline-blue-200 dark:hover:tw-outline-gray-700 hover:tw-outline-offset-0 dark:hover:tw-outline-offset-0`;
    }
    return tw `tw-outline-0 tw-outline-offset-0`;
}
export function getRingClass({ isHovered, isFocused }) {
    const ringBaseClassDef = tw `tw-ring-0 tw-ring-offset-0`;
    if (isFocused) {
        return tw `${ringBaseClassDef} focus:tw-ring-0 dark:focus:tw-ring-0 focus:tw-ring-offset-0 dark:focus:tw-ring-offset-0`;
    }
    if (isHovered) {
        return tw `${ringBaseClassDef} hover:tw-ring-0 dark:hover:tw-ring-0`;
    }
    return ringBaseClassDef;
}
export function getRoundedClass({ isHovered, isFocused }) {
    const roundedBaseClassDef = tw `tw-rounded-sm`;
    if (isFocused) {
        return tw `${roundedBaseClassDef} focus:tw-rounded-\[4px\]`;
    }
    if (isHovered) {
        return tw `${roundedBaseClassDef} hover:tw-rounded-\[4px\]`;
    }
    return roundedBaseClassDef;
}
export function getCursorClass({ disabled, readOnly }) {
    if (disabled || readOnly) {
        return tw `tw-cursor-not-allowed`;
    }
    return tw `tw-cursor-pointer`;
}
export function getLabelTextColorClass({ disabled }) {
    if (disabled) {
        return tw `tw-text-gray-400 dark:tw-text-gray-600`;
    }
    return tw `tw-text-primary dark:tw-text-gray-100`;
}
export function getLabelCursorClass({ disabled, readOnly }) {
    if (disabled || readOnly) {
        return tw `tw-cursor-not-allowed`;
    }
    return tw `tw-cursor-pointer`;
}
//# sourceMappingURL=checkbox.logic.js.map